class ConditionVariantSelector extends VariantSelector {
  constructor() {
    super();
    this.property = 'condition';

    this.value = false;
    this.displayValue = false;
    this.unavailableLabel = this.getAttribute('unavailable-label');
    this.formId = this.getAttribute('form-id');
    this.variantFontFamily = this.getAttribute('variant-font-family');

    this.options = [];
    this.wrapper = this.querySelector('.product-condition-selector');
    this.tooltip = this.querySelector('.product-condition-selector__tooltip');
    this.label = this.querySelector('.product-condition-selector__label');
    this.showWithoutSize = this.getAttribute('show-without-size') === 'true';
  }

  // This may be extended later to support hard-unavailable which would be OOS items.
  getAvailabilityClass(option) {
    return option.enabled ? '' : 'soft-unavailable';
  }

  setValue(value){
    super.setValue(value);
    const selected = this.querySelector(`[name="${this.property}-option"][value="${value}"`);
    selected.checked = true;
    this.updateLabel();
  }

  render(){
    const options = window.variants.getVariantData(this.property);
    let markup = '';

    options.forEach((option, index) => {
      const selectorID = `selector-${this.property}-${index}`;
      const availClass = this.getAvailabilityClass(option);

      markup += `<input id="${selectorID}" type="radio" form="${this.formId}" name="${this.property}-option" value="${option.value}" class="p-small ${availClass}" selected="false" aria-disabled="${!option.enabled}">
      <label for="${selectorID}" class="${this.variantFontFamily}">
        <span class="">${option.label}</span>
        <span class="visually-hidden">${!option.enabled ? this.unavailableLabel : ''}</span>
        <svg><line x1="0" y1="98%" x2="100%" y2="2%"></line></svg>
      </label>`;
    });

    this.wrapper.insertAdjacentHTML('beforeend', markup);

    this.wrapper.classList.toggle('hidden', options.length === 0);

    /* Set options within inputs to enable event listener attachment to each child. */
    this.options = this.querySelectorAll('input[type="radio"]');

    this.options.forEach((element) => {
      element.addEventListener('click', (event) => {
        const state = this.getOptionState(element.value);

        if (state?.softUnavailable) {
          element.checked = true;
          this.handleSoftUnavailableClick(element.value);
          this.updateLabel();
          return;
        }

        // Available: normal selection
        this.onValueChanged();
      });
    });
  }

  updateOptions(event){
    if (event.detail.property != this.property){
      const options = window.variants.getVariantData(this.property);
      const hasSizeProperty = !!window.variants.properties.find(element => element === 'size');

      // Size needs to be selected or '*' (all props updates) to show any conditions.
      const isSizeRequirementMet = this.showWithoutSize ||
        window.variants.hasVariantOptionSelected('size') ||
        event.detail.property == '*' ||
        !hasSizeProperty;

      if (isSizeRequirementMet) this.tooltip.classList.remove('hidden');

      options.forEach((option) => {
        const input = this.querySelector(`input[value="${option.value}"]`);
        const label = input.nextElementSibling;
        const unavailableLabel = label.querySelector('span.visually-hidden');
        const availClass = this.getAvailabilityClass(option);

        // Remove all availability classes
        input.classList.remove('disabled', 'soft-unavailable', 'hidden');
        label.classList.remove('hidden');

        if (option.enabled) {
          unavailableLabel.textContent = '';
        } else {
          input.classList.add(availClass);
          unavailableLabel.textContent = this.unavailableLabel;
        }
        input.setAttribute('aria-disabled', !option.enabled);
      });

      // Auto-select if only one option is available and nothing is selected
      if (!this.value) {
        const single = this.getSingleEnabledOption();
        if (single) {
          this.setValue(single.value);
          window.variants.setVariantOption(this.property, this.value);
        }
      }
    }
  }

  updateSelected(event) {
    if (event.detail.property == this.property){
      const selected = this.querySelector(`[name="${this.property}-option"][value="${event.detail.code}"]`);
      if (selected){
        selected.checked = true;
        this.updateLabel();
      }
    }
  }

  deselect() {
    super.deselect();
    this.label.innerHTML = '';
  }

  updateLabel() {
    const selected = this.querySelector(`[name="${this.property}-option"]:checked`);
    this.displayValue = this.querySelector(`label[for="${selected.id}"] span:first-child`).textContent;
    this.tooltip.dataset.acsbTooltip = `${this.property}: ${this.displayValue}`;
    this.label.innerHTML = this.displayValue;
  }

  onValueChanged(){
    const selected = this.querySelector(`[name="${this.property}-option"]:checked`);
    this.setValue(selected.value);
    window.variants.setVariantOption(this.property, this.value);
  }
}

customElements.define('condition-variant-selector', ConditionVariantSelector);
